import React from 'react'
import { motion } from 'framer-motion'
import '../css/copyright2.css'

const Copyright4 = () => {

    const d = new Date();
    let year = d.getFullYear(); 


    return (
    <>

    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1, transition: { duration: 0.7, delay: 3 } }} className='copy-cont'>
          <div className='copy-inner'><h5 style={{ marginTop: '2px' }}>&copy; GALANTIS { year }</h5></div>
    </motion.div>


    </>
    )
}

export default Copyright4